var render = function render(){var _vm=this,_c=_vm._self._c;return _c('agreement-editor')
}
var staticRenderFns = []

export { render, staticRenderFns }